import { G } from "../../constants/theme";

export default function Label({ children }) {
  return (
    <div
      style={{
        fontFamily: "monospace",
        fontSize: 10,
        letterSpacing: 3,
        color: G.green,
        textTransform: "uppercase",
        marginBottom: 12,
        display: "flex",
        alignItems: "center",
        gap: 10,
      }}
    >
      <span style={{ display: "block", width: 28, height: 1, background: G.green }} />
      {children}
    </div>
  );
}
